import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { EncryptDecryptService } from '../../../service/encrypt-decrypt.service';
declare let Swiper: any;
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import Swal from 'sweetalert2';
import { CustomServiceService } from './../../../service/custom-service.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrls: ['./whats-new.component.css']
})
export class WhatsNewComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute, private encDec: EncryptDecryptService, private route: Router, private httpservice: CustomServiceService,public translate: TranslateService) { }
  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  datetime:any = this.httpservice.currentDateTime(); 
  language:any = '';
  start:number=0;
  limit:number=10;
  currentPage:number = 1;
  totalRecords:any;
  content_apiresponse:any;
  ngOnInit(): void {
    // this.getLatestNews();
    this.language = sessionStorage.getItem('locale');
   // this.getWhatsNew();
    this.start=(this.currentPage - 1)*this.limit;
  this.getwhatsNewDetails(this.start,this.limit,this.currentPage,'');
  this.getomssDetails(this.start,this.limit,this.currentPage,'');
}
    // FOR WHAT'S NEW SWIPER CAROUSEL - STARTS
    // var swiper = new Swiper(".whats-new", {
    //   spaceBetween: 5,
    //   slidesPerView: 2,
    //   autoplay : {
    //     delay: 2000
    //   },
    //   breakpoints: {
    //     // When window width is >= 640px
    //     320: {
    //       slidesPerView: 1,
    //       spaceBetween: 40
    //     },
    //     // When window width is >= 768px
    //     768: {
    //       slidesPerView: 2,
    //       spaceBetween: 50
    //     }
    //     // Add more breakpoints as needed
    //   }
    // });
    // FOR WHAT'S NEW SWIPER CAROUSEL - ENDS


  mediaResponse: any;
  c_apirespons: any;
  current_data: any[] = [];
  RecruitmentLength: any;
  RecId: any;
  whatsnew: any;
  url: any;
  // getWhatsNew() {
  //   let params = [{
  //     "secSlNo": 1,
  //     "offSet": 0,
  //     "noOfRecords": 10,
  //     "orderBy": [{ "columnName": "intId", "type": "DESC" }],
  //     "condition": [
  //       { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
  //       { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
  //       { "columnName": "ZONE_ID", "operator": "=", "value": environment.ZONE_ID, "joinoperator": "and" },
  //     ],
  //     viewParameters: "",
  //   }];
  //   this.fciwebservice.getWhatsNew(params).subscribe((response: HttpEvent<any>) => {
  //     switch (response.type) {
  //       case HttpEventType.Sent:
  //         //console.log('Sent' + HttpEventType.Sent);
  //         break;
  //       case HttpEventType.ResponseHeader:
  //         //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
  //         break;
  //       case HttpEventType.UploadProgress:
  //         //this.evenTotal = response.total;
  //         //this.progress = Math.round(response.loaded / this.evenTotal * 100);
  //         break;
  //       case HttpEventType.Response:
  //         this.content_apiresponse = response.body;
  //         let respData = this.content_apiresponse.RESPONSE_DATA;
  //         let respToken = this.content_apiresponse.RESPONSE_TOKEN;
  //         let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
  //         if (respToken == verifyToken) {
  //           let response: any = Buffer.from(respData, 'base64');
  //           response = JSON.parse(response);
  //           this.whatsnew = response.result.sec_1;
  //           console.log( this.whatsnew );
  //           for (let i = 0; i < this.whatsnew.length; i++) {
  //             if (this.whatsnew[i]['type'] == 8) {
  //               this.RecId = this.whatsnew[i].selectRecruitmentTitle;
  //               let params = [
  //                 {
  //                   "secSlNo": 1,
  //                   "offSet": 0,
  //                   "noOfRecords": '',
  //                   "orderBy": [],
  //                   "condition": [
  //                     { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
  //                     { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
  //                     { "columnName": "intId", "operator": "=", "value": this.RecId, "joinoperator": "and" },
  //                   ],
  //                   "viewParameters": ""
  //                 }];
  //               this.httpservice.GetCurrnetRecruitment(params).subscribe((response: HttpEvent<any>) => {
  //                 switch (response.type) {
  //                   case HttpEventType.Sent:
  //                     //console.log('Sent' + HttpEventType.Sent);
  //                     break;
  //                   case HttpEventType.ResponseHeader:
  //                     //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
  //                     break;
  //                   case HttpEventType.UploadProgress:
  //                     //this.evenTotal = response.total;
  //                     //this.progress = Math.round(response.loaded / this.evenTotal * 100);
  //                     break;
  //                   case HttpEventType.Response:
  //                     this.c_apirespons = response.body;
  //                     let respData = this.c_apirespons.RESPONSE_DATA;
  //                     let respToken = this.c_apirespons.RESPONSE_TOKEN;
  //                     let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
  //                     if (respToken == verifyToken) {
  //                       let response: any = Buffer.from(respData, 'base64');
  //                       response = JSON.parse(response);
  //                       this.current_data = response.result.sec_1;
  //                       this.whatsnew[i]['url'] = this.current_data[0].redirectURL;;
  //                     }
  //                 }
  //               });
  //             }
  //           }
  //         }
  //     }
  //   });
  // }

  viewDetails(id: any, pageName: any) {
    if(pageName=="tender-details"){
      let encSchemeStr = this.encDec.encText(`${id.toString()}:false`);
      this.route.navigate(['./' + pageName + '/', encSchemeStr]);
    } else {
      let encSchemeStr = this.encDec.encText(id.toString());
      this.route.navigate(['./' + pageName + '/', encSchemeStr]);
    }
    
  }
  getSelectTenderTitle(item: any): string {
    const jsonOptTxtDetails = JSON.parse(item.jsonOptTxtDetails);
   
    return jsonOptTxtDetails.selectTenderTitle;
  }


  // getSelectTenderTitle(item: any, language: string): string {
  //   const jsonOptTxtDetails = JSON.parse(item.jsonOptTxtDetails);
  //   console.log(jsonOptTxtDetails);
  //   const tenderTitle = jsonOptTxtDetails.selectTenderTitle;
  
  //   if (language === 'English') {
  //     // You can modify or format the English title here if needed
  //     return tenderTitle;
  //   } else {
     
  //     return tenderTitle;
  //   }
  // }
  
  getSelectNewsTitle(item: any): string {
    const jsonOptTxtDetails = JSON.parse(item.jsonOptTxtDetails);
    return jsonOptTxtDetails.selectNewsTitle;
  }
  getSelectPressTitle(item: any): string {
    const jsonOptTxtDetails = JSON.parse(item.jsonOptTxtDetails);
    return jsonOptTxtDetails.selectPressReleaseTitle;
  }
  getSelectCircularTitle(item: any): string {
    const jsonOptTxtDetails = JSON.parse(item.jsonOptTxtDetails);
    return jsonOptTxtDetails.selectCircularTitle;
  }
  getSelectAwardTitle(item: any): string {
    const jsonOptTxtDetails = JSON.parse(item.jsonOptTxtDetails);
    return jsonOptTxtDetails.selectAwardTitle;
  }
  getSelectRecruitTitle(item: any): string {
    const jsonOptTxtDetails = JSON.parse(item.jsonOptTxtDetails);
    return jsonOptTxtDetails.selectRecruitmentTitle;
  }
  htmldecode(str: any) {
    return this.encDec.decodeHtml(str);
  }

  goToExtLink(url: any) {
    console.log(url);
    Swal.fire({
      title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
      }
    });
  }

  whatsnewDetails:any[]=[];
  omssDetails:any[]=[];
  arcType:any;
  
  getwhatsNewDetails(start:number,limit:number,currentPage:number,type:any){
    let params = {
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": '',
      "orderBy": '',
      "viewParameters": type,
      "bitDeletedFlag": 0,
      "OMSS": 0,
       "tinPublishStatus": 1,
       "typeCheck":false,
        "mytime":this.datetime.date
    };
      this.fciwebservice.getWhatsNewDetails(params).subscribe((response: HttpEvent<any>) => {
     switch (response.type) {
       case HttpEventType.Sent:
         //console.log('Sent' + HttpEventType.Sent);
         break;
       case HttpEventType.ResponseHeader:
         //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
         break;
       case HttpEventType.UploadProgress:
         //this.evenTotal = response.total;
         //this.progress = Math.round(response.loaded / this.evenTotal * 100);
         break;
       case HttpEventType.Response:
         this.content_apiresponse = response.body;
         let respData = this.content_apiresponse.RESPONSE_DATA;
         let respToken = this.content_apiresponse.RESPONSE_TOKEN;
         let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
         if (respToken == verifyToken) {
           let response: any = Buffer.from(respData, 'base64');
           response = JSON.parse(response);
         
           this.whatsnewDetails = response.result;
           this.arcType = type;
           if(response.result.length > 0){
           
            this.totalRecords = this.whatsnewDetails[0].count; 
                     
          } else {
            this.totalRecords = 0;
          }
        
         }
     }
   });
  }

  getomssDetails(start:number,limit:number,currentPage:number,type:any){
    let params = {
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": '',
      "orderBy": '',
      "viewParameters": type,
      "bitDeletedFlag": 0,
      "OMSS": 1,
       "tinPublishStatus": 1,
       "typeCheck":false,
        "mytime":this.datetime.date
    };
      this.fciwebservice.getWhatsNewDetails(params).subscribe((response: HttpEvent<any>) => {
     switch (response.type) {
       case HttpEventType.Sent:
         //console.log('Sent' + HttpEventType.Sent);
         break;
       case HttpEventType.ResponseHeader:
         //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
         break;
       case HttpEventType.UploadProgress:
         //this.evenTotal = response.total;
         //this.progress = Math.round(response.loaded / this.evenTotal * 100);
         break;
       case HttpEventType.Response:
         this.content_apiresponse = response.body;
         let respData = this.content_apiresponse.RESPONSE_DATA;
         let respToken = this.content_apiresponse.RESPONSE_TOKEN;
         let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
         if (respToken == verifyToken) {
           let response: any = Buffer.from(respData, 'base64');
           response = JSON.parse(response);
         
           this.omssDetails = response.result;
         }
     }
   });
  }

}
